module.exports = __webpack_public_path__ + "img/devicedetail1.08aeab08.png";